import { action } from './CodeSnippetAction.styles';

type Props = {
  title?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
};

export const CodeSnippetAction: React.FC<Props> = ({ title, icon, onClick }) => {
  return (
    <button type="button" className={action} onClick={onClick}>
      {icon}
      {title && <span>{title}</span>}
    </button>
  );
};
